import React from 'react';
import { Flex, Switch, Typography } from 'antd';

import { AutobroadcastFormComponentProps } from '../../service/autoBroadcast.interface';

export const AutoBroadcastEnableSwitcher = ({
    title,
    fieldName,
    formik,
}: AutobroadcastFormComponentProps) => {
    return (
        <Flex gap={24} align='center'>
            <Switch
                checked={formik.values[fieldName]}
                onChange={checked => formik.setFieldValue(fieldName, checked)}
            />
            <Typography.Title level={5} style={{ margin: 0 }}>
                {title}
            </Typography.Title>
        </Flex>
    );
};
